
//TODO: ajax support.

// Holds active slider instances.
var instances = {}
const touchendAutoCloseTimer = 4000;

function setInstance(context) {
    let id = context.attr(expressSelectors()['tooltip']['instance']);
    // If this tooltip has not been initialise then create new instance.
    if (!id) {
        id = generateId();
        // Assign id.
        context.attr('tooltip-id', id);
        // Create a new instance.
        instances[id] = {};
    }
    return id;
}

function getInstance(context) {
    return context.attr(expressSelectors()['tooltip']['instance']);
}

function setContent(id, content) {
    instances[id]['tooltipContent'] = content;
    return instances[id]['tooltipContent'];
}

function getContent(id) {
    return instances[id]['tooltipContent'];
}

function setContentContainer(id, container) {
    instances[id]['content-container'] = container
    return instances[id]['content-container'];
}

function getContentContainer(id) {
    return instances[id]['content-container'];
}



//----- Initialiser ----- 
function initialise(context) {
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Tooltip: Attempting to initialise tooltip.", context);
    }
    // Used for identifying the icon being used to trigger the content.
    let parentContainer = context.parents(expressSelectors()['tooltip']['container']);

    let alignment = "align-center";

    // If align left then overwrite default.
    alignment = (context.hasClass('align-left') ? "" : alignment);
    // If align right then overwrite default.
    alignment = (context.hasClass('align-right') ? "" : alignment);

    // If no parent container defined then fallback to the context.
    if (parentContainer.length == 0) {
        parentContainer = context;
        // Add in missing classes.
        parentContainer.addClass('tooltip-container ' + alignment);
    }
    // Tooltip trigger.
    let tooltipTrigger = parentContainer.find(expressSelectors()['tooltip']['trigger']);
    // If a trigger is not defined then fallback to context.
    if (tooltipTrigger.length == 0) {
        tooltipTrigger = context;
    }
    // Capture the content container.
    let tooltipContentContainer = parentContainer.find(expressSelectors()['tooltip']['content-container']);
    // If no content then check if title tag is defined if so then use that.
    if (tooltipContentContainer.length == 0 && context.attr('title')) {
        // Get title value.
        let tooltipContent = context.attr('title');
        // Update DOM.
        context.append('<div class=' + expressSelectors()['tooltip']['content-container'] + '><p>' + tooltipContent + '</p></div>');
        // Update tooltip content context.
        tooltipContentContainer = parentContainer.find(expressSelectors()['tooltip']['content-container']);
    }
    // Check again for content if still not defined then exit initialation.
    if (tooltipContentContainer.length == 0) {
        AXISDebug.output(3,"Tooltip: Cannot initialise tooltip due to no content being defined.", context);
        return false;
    }

    // Wrap content inside of container.
    if (context.find('.tooltip-content-container').length == 0) {
        tooltipContentContainer.wrap("<div class='tooltip-content-container'></div>");
    }
    
    //TODO: This idea could probably be improved but due to time constraints just going to default to mouseenter.
    // Get the trigger type.
    let eventTrigger = context.attr(expressSelectors()['tooltip']['event']);
    if (!eventTrigger) {
        eventTrigger = "mouseenter touchstart";
    }

    let id = setInstance(context);
    // Add instance properties.
    instances[id]['container'] = parentContainer;
    instances[id]['trigger'] = tooltipTrigger;
    //instances[id]['tooltipContent'] = tooltipContent;
    setContent(id, tooltipContentContainer.html());
    setContentContainer(id, tooltipContentContainer);
    instances[id]['eventTrigger'] = eventTrigger;
    // Assign id to trigger.
    tooltipTrigger.attr('tooltip-trigger', id);

    // TODO: tooltip event binding doesn't adapt to viewport resize.
    // Using mouseenter + touchstart + cooldown handles both modes simultaneously,
    // avoiding rebind-on-resize complexity. Refactor if tooltip behaviour expands.
    let lastFire = 0;
    let closeTimer = null;

    tooltipTrigger.on(eventTrigger, function(event) {
        const now = Date.now();
        if (now - lastFire < 300) return;
        lastFire = now;
        let isMobile = (currentBreakpoint() < 3);
        // Get tooltip content.
        let tooltipContent = tooltipContentContainer.parent('.tooltip-content-container');
        // Toggle active state.
        tooltipContent.toggleClass('active');
        if (!getViewPort(tooltipContent)) {
            let overlappingSide = getViewPortOverlapSide(tooltipContent);

            // If overlapping the right of the viewport then move the tooltop to the left.
            if (overlappingSide.hasOwnProperty('right')) {
                parentContainer.addClass('responsive-override-align-left');
            }
            // If overlapping left of the viewport then move the tooltip to the right.
            if (overlappingSide.hasOwnProperty("left")) {
                parentContainer.addClass('responsive-override-align-right');
            }
        } 
        // On mouse over of the trigger.
        if (eventTrigger.includes("mouseover") || eventTrigger.includes("mouseenter")) {
            tooltipTrigger.on('mouseleave', function() {
               
                let closeInterval = setInterval(function() {
                    // Stop interval.
                    clearInterval(closeInterval);
                    // Deactive the tooltips content.
                    tooltipContent.removeClass('active');
                    // As mouse leave listener is no longer needed then remove it.
                    tooltipTrigger.off('mouseleave');
                    tooltipContent.off('mouseenter mouseleave');

                    
                }, 10);
                // If the mouse is over the content then stop the interval.
                tooltipContent.on('mouseenter', function() {
                    clearInterval(closeInterval);
                    // On mouse leave close.
                    tooltipContent.on('mouseleave', function () {
                        // Deactivate tooltip content.
                        tooltipContent.removeClass('active');
                        // Remove listeners.
                        tooltipContent.off('mouseenter mouseleave');
                        tooltipTrigger.off('mouseleave');
                    });
                });
            });
        }
    }); 
    // Auto-close on mobile after a delay after touchend as fired from the trigger.
    tooltipTrigger.on('touchend', function() {
        clearTimeout(closeTimer);
        // Get tooltip content.
        let tooltipContent = tooltipContentContainer.parent('.tooltip-content-container');
        if (tooltipContent.hasClass('active')) {
            closeTimer = setTimeout(function() {
                tooltipContent.removeClass('active');
            }, touchendAutoCloseTimer);
        }
    });


    $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
        // Check to see if any responsive overrides have been applied as they may no longer be applicable.
        if (parentContainer.hasClass('responsive-override-align-left')) {
            parentContainer.removeClass('responsive-override-align-left');
        }
        if (parentContainer.hasClass('responsive-override-align-right')) {
            parentContainer.removeClass('responsive-override-align-right');
        }
    });
    return true;
}

function updateContent(id, content) {
    // Update instance obj.
    content = setContent(id, content);
    // Check whether new content containers HTML.
    let isHTML = containsHTML(content);

    if (!isHTML) {
        // As the content does not contain html then wrap content in a paragraph.
        content = "<p>" + content + "</p>";
    }
    // Update DOM.
    return getContentContainer(id).html(content);
    ;
}



function initialiseAll() {

    let tooltips = $(expressSelectors()['tooltip']['initialise']);
    // Loop through tooltips.
    tooltips.each(function() {
        // Capture tooltip context.
        let context = $(this);
        // Initialise tooltip.
        let intialiseTooltip = initialise(context);
        // If initialiser failed then output console error.
        if (!intialiseTooltip) {
            AXISDebug.output(3,"Failed to initialise tooltip.");
            return false;
        }
    });
}

var AXISTooltip = $.AXISTooltip = {
    initialise: (context) => {
        return initialise(context);
    }, 
    initialiseAll: () => {
        return initialiseAll();
    },
    getInstance: (context) => {
        return getInstance(context);
    },
    updateContent: (id, content) => {
        return updateContent(id, content);
    }
}

export { AXISTooltip }